var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1754 4.25009L10.2093 8.55778C1.49339 11.4727 1.49339 16.2255 10.2093 19.126L14.0575 20.4039L15.3354 24.2521C18.236 32.968 23.0031 32.968 25.9036 24.2521L30.2257 11.3003C32.1498 5.48496 28.9908 2.31163 23.1754 4.25009ZM23.6349 11.9752L18.1785 17.4603C17.9631 17.6757 17.6903 17.7762 17.4175 17.7762C17.1447 17.7762 16.8719 17.6757 16.6565 17.4603C16.2401 17.0439 16.2401 16.3547 16.6565 15.9383L22.1129 10.4532C22.5293 10.0368 23.2185 10.0368 23.6349 10.4532C24.0513 10.8696 24.0513 11.5588 23.6349 11.9752Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage2);
export default __webpack_public_path__ + "static/media/sendMessage (2).bbbcf3956fbd04194e138d61ef0056d5.svg";
export { ForwardRef as ReactComponent };